/* MANDARINA REPUBLIC — HOME v7 · hero con video
   Un video vertical a la vez, deslizable (scroll-snap nativo). Solo el video
   visible se reproduce; el siguiente se precarga; los demás esperan con su
   portada. Cuando el video termina, pasa solo al siguiente.
   Vive aparte de mrh.js a propósito: mrh.js sigue sirviendo el carrito, las
   tallas y el hero viejo (sections/mrh-hero.liquid), que queda como respaldo. */
(function (root) {
  'use strict';

  /* ─────────── ESTADO PURO (probado en test/estado.test.js) ───────────
     Qué slide está activo, si hay un dedo encima y si quedó un salto pendiente.
     No toca el DOM: devuelve acciones ({go: n} | {replay: true} | null). */
  function makeState(N) {
    var st = { active: 0, holding: false, pending: false };
    st.setActive = function (k) {
      st.active = ((k % N) + N) % N;
      st.pending = false; /* si el usuario se movió, lo que estaba pendiente ya no aplica */
      return st.active;
    };
    st.ended = function () {
      if (N < 2) return { replay: true };
      if (st.holding) { st.pending = true; return null; }
      return { go: (st.active + 1) % N };
    };
    st.hold = function (on) {
      st.holding = !!on;
      if (on || !st.pending) return null;
      st.pending = false;
      return { go: (st.active + 1) % N };
    };
    return st;
  }

  if (typeof module !== 'undefined' && module.exports) { module.exports = { makeState: makeState }; }
  if (typeof document === 'undefined') return;

  /* ─────────── DOM ─────────── */
  var RM = root.matchMedia && root.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var IMG_DELAY = 6000; /* un slide sin video (solo foto) dura esto */
  var noop = function () {};
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  function init(hero) {
    /* guardia: `shopify:section:load` vuelve a llamar a boot() en el editor */
    if (hero.__mrhReady) return;
    hero.__mrhReady = true;

    var track = hero.querySelector('[data-track]');
    var slides = $$('[data-slide]', hero);
    var N = slides.length;
    if (!track || N < 1) return;
    var videos = slides.map(function (s) { return s.querySelector('[data-video]'); });
    var bars = $$('[data-bar]', hero);
    var st = makeState(N);
    var imgTimer = null;
    var visible = true;

    function goTo(k, instant) {
      k = ((k % N) + N) % N;
      track.scrollTo({ left: k * track.clientWidth, behavior: (instant || RM) ? 'auto' : 'smooth' });
    }

    function act(a) {
      if (!a) return;
      if (a.replay) {
        var v = videos[st.active];
        if (v) { try { v.currentTime = 0; } catch (e) {} v.play().catch(noop); }
        return;
      }
      goTo(a.go);
    }

    /* un slide sin video, o cuyo video no arranca, avanza con reloj */
    function armClock(k) {
      clearTimeout(imgTimer);
      if (RM || N < 2) return;
      imgTimer = setTimeout(function () { if (st.active === k && visible) act(st.ended()); }, IMG_DELAY);
    }

    function paintBars(k) {
      bars.forEach(function (b, j) {
        b.classList.toggle('is-active', j === k);
        b.setAttribute('aria-selected', j === k ? 'true' : 'false');
        b.style.setProperty('--p', j < k ? '1' : '0');
      });
    }

    function activate(k) {
      k = st.setActive(k);
      clearTimeout(imgTimer);
      slides.forEach(function (s, j) { s.classList.toggle('is-active', j === k); });
      paintBars(k);
      videos.forEach(function (v, j) {
        if (!v) return;
        if (j === k) return;
        v.pause();
        try { v.currentTime = 0; } catch (e) {}
      });
      var v = videos[k];
      if (!v) { armClock(k); }
      else if (RM) { v.controls = true; }
      else if (visible) { playActive(v, k); }
      /* el siguiente se precarga para que el cambio no muestre la portada */
      var nx = videos[(k + 1) % N];
      if (nx && nx.preload === 'none') nx.preload = 'auto';
    }

    function playActive(v, k) {
      v.muted = true;
      var p = v.play();
      if (p && p.catch) {
        p.then(function () { slides[k].classList.remove('is-blocked'); })
         .catch(function () {
           /* autoplay bloqueado (modo ahorro de batería en iPhone): se muestra
              el botón ▶ y el slide avanza con reloj para no quedarse clavado */
           slides[k].classList.add('is-blocked');
           armClock(k);
         });
      }
    }

    videos.forEach(function (v, j) {
      if (!v) return;
      v.addEventListener('ended', function () { if (j === st.active) act(st.ended()); });
      v.addEventListener('timeupdate', function () {
        if (j !== st.active || !v.duration || !bars[j]) return;
        bars[j].style.setProperty('--p', (v.currentTime / v.duration).toFixed(3));
      });
      v.addEventListener('error', function () { if (j === st.active) armClock(j); });
      /* tocar el ▶ cuando el navegador bloqueó el autoplay */
      var play = slides[j].querySelector('[data-play]');
      if (play) play.addEventListener('click', function (e) { e.preventDefault(); playActive(v, j); });
    });

    /* qué slide está a la vista: lo dice el propio scroll-snap */
    if ('IntersectionObserver' in root) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (!en.isIntersecting || en.intersectionRatio < 0.6) return;
          var k = slides.indexOf(en.target);
          if (k !== -1 && k !== st.active) activate(k);
        });
      }, { root: track, threshold: [0.6] });
      slides.forEach(function (s) { io.observe(s); });

      /* fuera de pantalla (el cliente bajó a ver productos) no se gasta batería */
      var ioHero = new IntersectionObserver(function (entries) {
        visible = entries[0].isIntersecting;
        var v = videos[st.active];
        if (!visible) { clearTimeout(imgTimer); if (v) v.pause(); }
        else if (v && !RM) playActive(v, st.active);
        else if (!v) armClock(st.active);
      }, { threshold: 0.15 });
      ioHero.observe(hero);
    }

    /* con el dedo encima no se salta solo: se espera a que lo suelte */
    track.addEventListener('pointerdown', function () { st.hold(true); }, { passive: true });
    ['pointerup', 'pointercancel'].forEach(function (ev) {
      track.addEventListener(ev, function () { act(st.hold(false)); }, { passive: true });
    });

    bars.forEach(function (b, j) { b.addEventListener('click', function () { goTo(j); }); });
    var prev = hero.querySelector('[data-prev]'), next = hero.querySelector('[data-next]');
    if (prev) prev.addEventListener('click', function () { goTo(st.active - 1); });
    if (next) next.addEventListener('click', function () { goTo(st.active + 1); });
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(st.active - 1); }
      if (e.key === 'ArrowRight') { e.preventDefault(); goTo(st.active + 1); }
    });

    document.addEventListener('visibilitychange', function () {
      var v = videos[st.active];
      if (document.hidden) { clearTimeout(imgTimer); if (v) v.pause(); }
      else if (visible) { if (v && !RM) playActive(v, st.active); else if (!v) armClock(st.active); }
    });

    /* al girar el celular el ancho cambia: se vuelve a alinear el slide activo */
    var rT = null;
    root.addEventListener('resize', function () {
      clearTimeout(rT);
      rT = setTimeout(function () { goTo(st.active, true); }, 120);
    }, { passive: true });

    activate(0);
  }

  function boot() { $$('[data-mrh-vhero]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})(typeof window !== 'undefined' ? window : this);
